export default __webpack_public_path__ + "static/media/02.0d23ef79.jpg";